/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  EditOperationsTaskInput,
  OperationsTask,
  OperationsTaskType,
} from "../models/index";
import {
  EditOperationsTaskInputFromJSON,
  EditOperationsTaskInputToJSON,
  OperationsTaskFromJSON,
  OperationsTaskToJSON,
  OperationsTaskTypeFromJSON,
  OperationsTaskTypeToJSON,
} from "../models/index";

export interface ClearOperationsTaskCarrierTurnRequest {
  operationsTaskId: string;
}

export interface ClearOperationsTaskCustomerTurnRequest {
  operationsTaskId: string;
}

export interface CloseOperationsTaskRequest {
  operationsTaskId: string;
}

export interface DeleteOperationsTaskRequest {
  operationsTaskId: string;
}

export interface EditOperationsTaskRequest {
  editOperationsTaskInput: EditOperationsTaskInput;
}

export interface GetByShipmentIdRequest {
  shipmentId: string;
}

export interface GetByShipmentIdAndTypeRequest {
  shipmentId: string;
  taskType: OperationsTaskType;
}

export interface GetOldestNotDoneByShipmentIdRequest {
  shipmentId: string;
}

export interface GetOperationsTaskByIdRequest {
  operationsTaskId: string;
}

export interface MarkAsMonitoringRequest {
  operationsTaskId: string;
  isMonitoring: boolean;
}

export interface MarkOperationsTaskAsWaitingForCarrierRequest {
  operationsTaskId: string;
}

export interface MarkOperationsTaskAsWaitingForCustomerRequest {
  operationsTaskId: string;
}

export interface ReopenOperationalTaskRequest {
  operationsTaskId: string;
}

export interface SetOperationsAssigneeRequest {
  shipmentId: string;
  assignedTo?: string | null;
}

export interface SetOperationsAssigneesBulkRequest {
  shipmentIds: Array<string>;
  assignedTo?: string | null;
}

/**
 *
 */
export class OperationsTaskApi extends runtime.BaseAPI {
  /**
   */
  async clearOperationsTaskCarrierTurnRaw(
    requestParameters: ClearOperationsTaskCarrierTurnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["operationsTaskId"] == null) {
      throw new runtime.RequiredError(
        "operationsTaskId",
        'Required parameter "operationsTaskId" was null or undefined when calling clearOperationsTaskCarrierTurn().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["operationsTaskId"] != null) {
      queryParameters["operationsTaskId"] =
        requestParameters["operationsTaskId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/clear-operational-task-carrier-turn`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async clearOperationsTaskCarrierTurn(
    requestParameters: ClearOperationsTaskCarrierTurnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.clearOperationsTaskCarrierTurnRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async clearOperationsTaskCustomerTurnRaw(
    requestParameters: ClearOperationsTaskCustomerTurnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["operationsTaskId"] == null) {
      throw new runtime.RequiredError(
        "operationsTaskId",
        'Required parameter "operationsTaskId" was null or undefined when calling clearOperationsTaskCustomerTurn().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["operationsTaskId"] != null) {
      queryParameters["operationsTaskId"] =
        requestParameters["operationsTaskId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/clear-operational-task-customer-turn`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async clearOperationsTaskCustomerTurn(
    requestParameters: ClearOperationsTaskCustomerTurnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.clearOperationsTaskCustomerTurnRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async closeOperationsTaskRaw(
    requestParameters: CloseOperationsTaskRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["operationsTaskId"] == null) {
      throw new runtime.RequiredError(
        "operationsTaskId",
        'Required parameter "operationsTaskId" was null or undefined when calling closeOperationsTask().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["operationsTaskId"] != null) {
      queryParameters["operationsTaskId"] =
        requestParameters["operationsTaskId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/close-operations-task`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async closeOperationsTask(
    requestParameters: CloseOperationsTaskRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.closeOperationsTaskRaw(requestParameters, initOverrides);
  }

  /**
   */
  async deleteOperationsTaskRaw(
    requestParameters: DeleteOperationsTaskRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["operationsTaskId"] == null) {
      throw new runtime.RequiredError(
        "operationsTaskId",
        'Required parameter "operationsTaskId" was null or undefined when calling deleteOperationsTask().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["operationsTaskId"] != null) {
      queryParameters["operationsTaskId"] =
        requestParameters["operationsTaskId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/delete-operations-task`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteOperationsTask(
    requestParameters: DeleteOperationsTaskRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteOperationsTaskRaw(requestParameters, initOverrides);
  }

  /**
   */
  async editOperationsTaskRaw(
    requestParameters: EditOperationsTaskRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["editOperationsTaskInput"] == null) {
      throw new runtime.RequiredError(
        "editOperationsTaskInput",
        'Required parameter "editOperationsTaskInput" was null or undefined when calling editOperationsTask().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/operations-task/edit-operations-task`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: EditOperationsTaskInputToJSON(
          requestParameters["editOperationsTaskInput"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async editOperationsTask(
    requestParameters: EditOperationsTaskRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.editOperationsTaskRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getAllOperationsTasksRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<OperationsTask>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/get-all-operations-tasks`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(OperationsTaskFromJSON),
    );
  }

  /**
   */
  async getAllOperationsTasks(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<OperationsTask>> {
    const response = await this.getAllOperationsTasksRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getByShipmentIdRaw(
    requestParameters: GetByShipmentIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<OperationsTask>>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling getByShipmentId().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/get-by-shipment-id`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(OperationsTaskFromJSON),
    );
  }

  /**
   */
  async getByShipmentId(
    requestParameters: GetByShipmentIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<OperationsTask>> {
    const response = await this.getByShipmentIdRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getByShipmentIdAndTypeRaw(
    requestParameters: GetByShipmentIdAndTypeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OperationsTask>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling getByShipmentIdAndType().',
      );
    }

    if (requestParameters["taskType"] == null) {
      throw new runtime.RequiredError(
        "taskType",
        'Required parameter "taskType" was null or undefined when calling getByShipmentIdAndType().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    if (requestParameters["taskType"] != null) {
      queryParameters["taskType"] = requestParameters["taskType"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/get-by-shipment-id-and-type`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OperationsTaskFromJSON(jsonValue),
    );
  }

  /**
   */
  async getByShipmentIdAndType(
    requestParameters: GetByShipmentIdAndTypeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OperationsTask> {
    const response = await this.getByShipmentIdAndTypeRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getOldestNotDoneByShipmentIdRaw(
    requestParameters: GetOldestNotDoneByShipmentIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OperationsTask>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling getOldestNotDoneByShipmentId().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/get-oldest-open`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OperationsTaskFromJSON(jsonValue),
    );
  }

  /**
   */
  async getOldestNotDoneByShipmentId(
    requestParameters: GetOldestNotDoneByShipmentIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OperationsTask> {
    const response = await this.getOldestNotDoneByShipmentIdRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getOperationsTaskByIdRaw(
    requestParameters: GetOperationsTaskByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OperationsTask>> {
    if (requestParameters["operationsTaskId"] == null) {
      throw new runtime.RequiredError(
        "operationsTaskId",
        'Required parameter "operationsTaskId" was null or undefined when calling getOperationsTaskById().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["operationsTaskId"] != null) {
      queryParameters["operationsTaskId"] =
        requestParameters["operationsTaskId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/get-by-id`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OperationsTaskFromJSON(jsonValue),
    );
  }

  /**
   */
  async getOperationsTaskById(
    requestParameters: GetOperationsTaskByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OperationsTask> {
    const response = await this.getOperationsTaskByIdRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async markAsMonitoringRaw(
    requestParameters: MarkAsMonitoringRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["operationsTaskId"] == null) {
      throw new runtime.RequiredError(
        "operationsTaskId",
        'Required parameter "operationsTaskId" was null or undefined when calling markAsMonitoring().',
      );
    }

    if (requestParameters["isMonitoring"] == null) {
      throw new runtime.RequiredError(
        "isMonitoring",
        'Required parameter "isMonitoring" was null or undefined when calling markAsMonitoring().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["operationsTaskId"] != null) {
      queryParameters["operationsTaskId"] =
        requestParameters["operationsTaskId"];
    }

    if (requestParameters["isMonitoring"] != null) {
      queryParameters["isMonitoring"] = requestParameters["isMonitoring"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/mark-as-monitoring`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async markAsMonitoring(
    requestParameters: MarkAsMonitoringRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.markAsMonitoringRaw(requestParameters, initOverrides);
  }

  /**
   */
  async markOperationsTaskAsWaitingForCarrierRaw(
    requestParameters: MarkOperationsTaskAsWaitingForCarrierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["operationsTaskId"] == null) {
      throw new runtime.RequiredError(
        "operationsTaskId",
        'Required parameter "operationsTaskId" was null or undefined when calling markOperationsTaskAsWaitingForCarrier().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["operationsTaskId"] != null) {
      queryParameters["operationsTaskId"] =
        requestParameters["operationsTaskId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/mark-operational-task-as-waiting-for-carrier`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async markOperationsTaskAsWaitingForCarrier(
    requestParameters: MarkOperationsTaskAsWaitingForCarrierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.markOperationsTaskAsWaitingForCarrierRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async markOperationsTaskAsWaitingForCustomerRaw(
    requestParameters: MarkOperationsTaskAsWaitingForCustomerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["operationsTaskId"] == null) {
      throw new runtime.RequiredError(
        "operationsTaskId",
        'Required parameter "operationsTaskId" was null or undefined when calling markOperationsTaskAsWaitingForCustomer().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["operationsTaskId"] != null) {
      queryParameters["operationsTaskId"] =
        requestParameters["operationsTaskId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/mark-operational-task-as-waiting-for-customer`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async markOperationsTaskAsWaitingForCustomer(
    requestParameters: MarkOperationsTaskAsWaitingForCustomerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.markOperationsTaskAsWaitingForCustomerRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async reopenOperationalTaskRaw(
    requestParameters: ReopenOperationalTaskRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["operationsTaskId"] == null) {
      throw new runtime.RequiredError(
        "operationsTaskId",
        'Required parameter "operationsTaskId" was null or undefined when calling reopenOperationalTask().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["operationsTaskId"] != null) {
      queryParameters["operationsTaskId"] =
        requestParameters["operationsTaskId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/reopen-operational-task`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async reopenOperationalTask(
    requestParameters: ReopenOperationalTaskRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.reopenOperationalTaskRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setOperationsAssigneeRaw(
    requestParameters: SetOperationsAssigneeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling setOperationsAssignee().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    if (requestParameters["assignedTo"] != null) {
      queryParameters["assignedTo"] = requestParameters["assignedTo"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/set-operations-assignee`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setOperationsAssignee(
    requestParameters: SetOperationsAssigneeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setOperationsAssigneeRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setOperationsAssigneesBulkRaw(
    requestParameters: SetOperationsAssigneesBulkRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["shipmentIds"] == null) {
      throw new runtime.RequiredError(
        "shipmentIds",
        'Required parameter "shipmentIds" was null or undefined when calling setOperationsAssigneesBulk().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentIds"] != null) {
      queryParameters["shipmentIds"] = requestParameters["shipmentIds"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    if (requestParameters["assignedTo"] != null) {
      queryParameters["assignedTo"] = requestParameters["assignedTo"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/operations-task/set-operations-assignees-bulk`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setOperationsAssigneesBulk(
    requestParameters: SetOperationsAssigneesBulkRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setOperationsAssigneesBulkRaw(requestParameters, initOverrides);
  }
}
